import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { from, BehaviorSubject } from 'rxjs';
import Event from '../interfaces/Event';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  events$ = new BehaviorSubject([]);
  constructor(private afs: AngularFirestore) {}

  getEvents() {
    const eventRef: AngularFirestoreCollection<any> = this.afs.collection('events');
    return from(eventRef.valueChanges());
  }

  getUnarchivedEvents() {
    const now = moment(new Date()).format('YYYY-MM-DD');
    const eventsRef: AngularFirestoreCollection<any> = this.afs.collection('events', (ref) =>
      ref.where('archived', '==', false)
    );
    this.archivePastEvents();
    return from(eventsRef.valueChanges());
  }

  archivePastEvents() {
    const now = moment(new Date()).format('YYYY-MM-DD');
    const eventsRef: AngularFirestoreCollection<any> = this.afs.collection('events', (ref) => {
        return ref.where('dateTime.endDate', '<', now)
      }
    );
    from(eventsRef.valueChanges()).subscribe((eventsRes) => {
      if (eventsRes) {
        eventsRes.forEach(e => {
          if (!e.archived && !e.autoArchiveOverride) {
            e.archived = true;
            this.updateEvent(e.id, e);
          }
        })
      }
    })
  }

  getEventMembers(id) {
    const membersRef: AngularFirestoreCollection<any> = this.afs.collection('users', (ref) =>
      ref.where('events', 'array-contains', id)
    );
    return from(membersRef.valueChanges());
  }

  createEvent(eventData: Event) {
    return new Promise((resolve, reject) => {
      this.afs
        .collection('events')
        .add(eventData)
        .then((dRef) => {
          dRef.update({ id: dRef.id }).then(() => {
            resolve(dRef.id);
          });
        });
    });
  }

  getCurrentEvent(id) {
    const eventRef: AngularFirestoreCollection<any> = this.afs.collection('events', (ref) => ref.where('id', '==', id));
    return from(eventRef.valueChanges());
  }
  getCurrentUserOwnedEvents(uid) {
    const userEventsRef: AngularFirestoreCollection<any> = this.afs.collection('events', (ref) =>
      ref.where('owner', '==', uid)
    );
    return from(userEventsRef.valueChanges());
  }
  getCurrentUserEvents(userEvents) {
    let events = [];
    userEvents.forEach((ue) => {
      const userEventsRef: AngularFirestoreCollection<any> = this.afs.collection('events', (ref) =>
        ref.where('id', '==', ue)
      );
      events.push(from(userEventsRef.valueChanges()));
    });
    this.events$.next(events);
    return this.events$;
  }
  updateEvent(eventId, d) {
    const eventRef: AngularFirestoreDocument<any> = this.afs.doc(`events/${eventId}`);
    return eventRef.update(d);
  }

  deleteEvent(eventId) {
    const eventRef: AngularFirestoreDocument<any> = this.afs.doc(`events/${eventId}`);
    return eventRef.delete();
  }
}
